<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2 text-center">
      <h2 class="mb-2 text-center">Verify Code</h2>
      You should receive a 6-digit code.  Enter it below along with your new password.
    </div>

    <v-form ref="form" @submit.prevent="verifyClick" autocomplete="off">
      <v-otp-input 
        length="6" class="mb-4"
        type="number"
        v-model="code"
        :rules="[required, valid_code]"
      />

      <v-text-field
        v-model="password"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Password"
        :rules="[required, valid_password]"
        placeholder=" " persistent-placeholder
        autocomplete="new-password" autocapitalize="none"
        validate-on-blur
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />

      <v-text-field
        v-model="confirmation"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Confirm Password"
        :rules="[required, matches_password]"
        @blur="$refs.form.validate()"
        placeholder=" " persistent-placeholder
        autocomplete="new-confirm" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />

      <div class="mt-n2">
        <div class="pb-2" style="font-size: 12px;">
          By checking the box below, I acknowledge that I have <strong>read</strong> and
          <strong>agree</strong> to the terms of the PartnerLists
          <router-link :to="{ name: 'login/tos' }">Pro Terms of Service</router-link> and
          <router-link :to="{ name: 'login/privacy' }">Privacy Policy</router-link>
        </div>
        <v-checkbox 
          v-model="agree_to_terms"
          :rules="[required]"
          dense hide-details="true"
          class="mb-4"
        >
          <template #label>
            <div style="font-size: 14px;">
              I have read and agree.
            </div>
          </template>
        </v-checkbox>
      </div>

      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Set Password</v-btn>
      </div>
    </v-form>

    <div class="ml-3 mt-5 mb-2">
      Didn't receive your code?
      <a @click.prevent="requestAgain">Request again.</a>
    </div>
    <ErrorOverlay
      title="Verfication Error"
      v-model="error_dialog"
      :loading="loading"
      :message="error_message"
    />
  </div>
</template>

<script>

import { ErrorOverlay } from '@/components/pages'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { required, valid_code, valid_password, matches } from '@/lib/validations'

export default {
  name: 'ClaimVerify',

  props: ['claim_token'],

  components: { ErrorOverlay },

  data() {
    return {
      code: '',
      password: '',
      confirmation: '',
      pw_visible: false,
      agree_to_terms: false,


      // validation rules
      required,
      valid_code,
      valid_password,

      // error handling
      loading: false,
      error_dialog: false,
      error_message: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['unclaimedProUser']),

    // validation rules requiring access to data
    matches_password() { return matches(this.password, 'Password') }
  },

  methods: {
    ...mapActions('auth', ['loadUnclaimedProUser', 'resetPassword']),
    ...mapMutations('alerts', ['SNOOZE']),

    async verifyClick() {
      if (this.$refs.form.validate()) {

        this.loading = true
        const result = await this.resetPassword({
          pro_user_id: this.unclaimedProUser.pro_user_id,
          password_recovery_code: this.code,
          password: this.password,
          accepted: true,
        })
        this.loading = false
        
        if (result.ok) {
          // give them a break on asking for credit cards
          this.SNOOZE('payment_method')
          this.$router.replace({ name: 'home' })
        } else {
          this.error_message = result.error
          this.error_dialog = true

        }
      } 
    },

    requestAgain() {
      const { claim_token } = this
      this.$router.replace({ name: 'claim/user', params: { claim_token } })
    },
  },

  created() {
    this.loadUnclaimedProUser(this.claim_token)
  },
}
</script>
